import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Loader2, Users } from 'lucide-react';
import { API } from '../config/api';

const DAY_ORDER = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

export default function ScheduleSurveyPanel() {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/survey/schedule`, { withCredentials: true })
      .then((r) => setData(r.data))
      .catch(() => setData({ slots: [], ranked_top: [], participation: { respondents: 0, total_clients: 0, rate: 0 } }));
  }, []);

  if (!data) {
    return <Card className="bg-white border-[#E9DDCC] rounded-2xl"><CardContent className="py-10 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-[#C99A55]" /></CardContent></Card>;
  }

  const p = data.participation;
  const groups = [
    { key: 'planned', title: 'Créneaux prévus', slots: data.slots.filter((s) => s.planned) },
    { key: 'candidate', title: 'Créneaux proposés', slots: data.slots.filter((s) => !s.planned) },
  ];

  return (
    <Card className="bg-white border-[#E9DDCC] rounded-2xl" data-testid="survey-admin-panel">
      <CardHeader>
        <CardTitle className="font-heading text-xl text-[#493329]">Sondage horaires — résultats</CardTitle>
        <p className="text-xs text-[#7A6455]">Pourcentages calculés uniquement sur les clientes ayant répondu.</p>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex flex-wrap gap-3">
          <div className="flex items-center gap-2 bg-[#F0E8D9] rounded-xl px-4 py-2.5" data-testid="survey-participation">
            <Users className="w-4 h-4 text-[#C99A55]" />
            <span className="text-sm text-[#493329]">
              <strong>{p.respondents}</strong> répondante(s) sur {p.total_clients} cliente(s) — {p.rate}% de participation
            </span>
          </div>
        </div>

        {groups.map((g) => (
          <div key={g.key}>
            <h3 className="text-sm font-semibold text-[#493329] mb-3">{g.title}</h3>
            <div className="space-y-2">
              {g.slots
                .slice()
                .sort((a, b) => DAY_ORDER.indexOf(a.day) - DAY_ORDER.indexOf(b.day) || a.start.localeCompare(b.start))
                .map((s) => (
                <div key={s.slot_key} className="flex items-center gap-3" data-testid={`survey-row-${s.slot_key}`}>
                  <div className="w-40 flex-shrink-0 text-xs text-[#493329]">{s.day} {s.start}</div>
                  <div className="flex-1 h-5 bg-[#F0E8D9] rounded-full overflow-hidden relative">
                    <div className="h-full bg-[#8C9B86]" style={{ width: `${s.pct_oui}%` }} />
                  </div>
                  <div className="w-44 flex-shrink-0 text-xs text-[#7A6455] text-right">
                    <span className="text-[#8C9B86] font-semibold">{s.oui} oui</span> · <span className="text-[#C76542]">{s.non} non</span>
                    {s.respondents > 0 && <span className="ml-1 text-[#493329]">({s.pct_oui}%)</span>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
